function Footer(){
    return(
    <footer className="bg-dark p-3 fixed-bottom">
        <p className="text-white text-center m-0">MovFlix - All rights reserved - 2021</p>
    </footer>

    )
}
export default Footer